module.exports = __webpack_public_path__ + "img/p.66176f49.jpg";